module.exports = __webpack_public_path__ + "img/Kk.85ed870b.png";